/**
 * Note. Typographic empty and error states for inside a Sheet. No
 * illustration, no sticker: a title, one calm line, and optionally one
 * action. Errors carry a coral dot and a real retry.
 */

import type { ReactNode } from "react";

export interface NoteProps {
  title: string;
  body?: ReactNode;
  action?: ReactNode;
  tone?: "empty" | "error";
  center?: boolean;
}

export function Note({ title, body, action, tone = "empty", center = false }: NoteProps) {
  return (
    <div
      className="st-note"
      data-tone={tone}
      data-center={center || undefined}
      role={tone === "error" ? "alert" : undefined}
    >
      <p className="st-note__title">{title}</p>
      {body ? <p className="st-note__body">{body}</p> : null}
      {action ? <div style={{ marginTop: 6 }}>{action}</div> : null}
    </div>
  );
}
